export type PortalSession = {
  authUserId: string;
  portalUserId: string;
  orgId: string;
  tenantId: string;
  name: string;
  email: string;
  role: string;
  orgName: string;
  orgStatus: string;
};

export const PORTAL_SESSION_KEY = "opscom_portal_session";

export function readPortalSession(): PortalSession | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(PORTAL_SESSION_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as PortalSession;
    if (!parsed?.authUserId || !parsed?.portalUserId || !parsed?.orgId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writePortalSession(session: PortalSession): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(PORTAL_SESSION_KEY, JSON.stringify(session));
}

export function clearPortalSession(): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(PORTAL_SESSION_KEY);
  window.localStorage.removeItem("ockham_portal_customer");
  window.localStorage.removeItem("opscom_portal_customer");
}
